import { ContentChild } from './content-child';
import { ContentTreeNode } from './content-tree-node';

/**
 * Content blocks are the building blocks of a nested form. A content block can zero to many content entries of the
 * following types, all represented by LOP-ENTRY blocks in the XML:
 * - Zero or one chapter number AND a heading, represented by the following XML:
 *   <LOP-CONTENT>
 *     <LOP-ENTRY>
 *       <SETCHAPNUM>1.1</SETCHAPNUM>
 *       <HEADING EXPANDABLE="NO" translate="yes">Result of the Training Ojectives</HEADING>
 *     </LOP-ENTRY>
 *     [...]
 *   </LOP-CONTENT>
 * - Zero or many checkpoints, represented by the following XML:
 *   <LOP-CONTENT>
 *     [...]
 *     <LOP-ENTRY>
 *       <CHECKPNT OCCURANCE="1" TYPE="-" translate="yes">Test</CHECKPNT>
 *       <CHECKBTN>
 *         <PDFFORM HEIGHT="12" TITLE="CheckPnt_1.1.1_2" TYPE="RADIOBTN.VALUE1" WIDTH="12"></PDFFORM>
 *         <PDFFORM HEIGHT="12" TITLE="CheckPnt_1.1.1_2" TYPE="RADIOBTN.VALUE2" WIDTH="12"></PDFFORM>
 *         <PDFFORM HEIGHT="12" TITLE="CheckPnt_1.1.1_2" TYPE="RADIOBTN.VALUE3" WIDTH="12"></PDFFORM>
 *       </CHECKBTN>
 *     </LOP-ENTRY>
 *     [...]
 *   </LOP-CONTENT>
 * - One functional elements, represented by the following (abbreviated) XML:
 *   <LOP-CONTENT>
 *     [...]
 *     <LOP-ENTRY>
 *       <LOP-TABLE>
 *         <TABLE LOP-GROUP-ID="CHECKPOINT_INDEPENDENT" LOP-TABLE-ID="DISCREPANCY_LOG" [...] >
 *             <TABTITLE [...] >Discrepancy Log</TABTITLE>
 *             <TGROUP>[...]</TGROUP>
 *         </TABLE>
 *       </LOP-TABLE>
 *     </LOP-ENTRY>
 *     [...]
 *   </LOP-CONTENT>
 * - Zero to many nested content blocks, represented by the following (abbreviated) XML:
 *   <LOP-CONTENT>
 *     [...]
 *     <LOP-CONTENT>
 *       [...]
 *     </LOP-CONTENT>
 *     [...]
 *   </LOP-CONTENT>
 *
 * Blocks can be chained. The parent <-> child relationship is modelled using the parentId property of the XmlTreeNode
 * type, which a content block uses.
 */
export type ContentBlock = Readonly<{
    id: ContentId;
    children: ContentChild[];
    visible?: boolean; // only used in Cosima
    xmlId?: string;
    topicMaterialNumbers?: string[];
}> &
    ContentTreeNode;

export type ContentId = number;

export const initialContentBlockState: ContentBlock = {
    id: -1,
    children: [],
    parentId: -1,
    xmlId: '',
    topicMaterialNumbers: [],
};
